const Checkbox = {
  parts: ['control'],
  baseStyle: {
    control: {
      borderColor: 'complementary.black',
      borderRadius: '4px',
      borderWidth: '1.5px',
      _checked: {
        color: 'complementary.black',
        background: 'inherit',
        borderColor: 'complementary.black',
        _hover: {
          background: 'unset',
          borderColor: 'complementary.black',
        },
      },
    },
    label: {
      marginLeft: '8px',
    },
  },
  sizes: {
    sm: {
      control: {
        h: 3,
        w: 3,
      },
      label: {
        fontSize: 'sm',
      },
      icon: {
        fontSize: '0.45rem',
      },
    },
    md: {
      control: {
        w: '18px',
        h: '18px',
      },
      label: {
        fontSize: 'md',
      },
      icon: {
        fontSize: '0.5rem',
      },
    },
    lg: {
      control: {
        w: 5,
        h: 5,
      },
      label: {
        fontSize: 'lg',
      },
      icon: {
        fontSize: '0.625rem',
      },
    },
  },
  defaultProps: {
    size: 'md',
  },
};

export default Checkbox;
